import React from 'react'

const Banner = () => {
    return (
        <div>
            {/* <!-- Banner start --> */}
            <div className="banner" id="banner">
                <div id="bannerCarousole" className="carousel slide" data-ride="carousel">
                    <div className="carousel-inner banner-slider-inner text-center">
                        <div className="carousel-item banner-max-height active item-bg">
                            <img style={{opacity: '0.4'}} className="d-block w-100 h-100" src="https://firebasestorage.googleapis.com/v0/b/wti-services-jrz.appspot.com/o/banner-01.png?alt=media&token=8fbc8527-c6ab-4894-9cb7-218658f7cf34" alt="banner"/>
                            <div className="carousel-content container banner-info-2 bi-2">
                                <h2>Bienvenido a WTI Servicios Aduanales</h2>
                                <p>Encuentra los mejores precios para importar tu automovil.</p>
                                <a href="#" className="btn btn-lg btn-round btn-theme">Cotiza ahora</a>
                            </div>
                        </div>
                        <div className="carousel-item banner-max-height item-bg">
                            <img className="d-block w-100 h-100" src="https://firebasestorage.googleapis.com/v0/b/wti-services-jrz.appspot.com/o/banner-02.png?alt=media&token=24d264cd-8dec-4010-85da-97f129d8ea2c" alt="banner"/>
                            <div className="carousel-content container banner-info-2 bi-2 text-l">
                                <h2>Importa tu auto</h2>
                                <p>Busca el costo de tu importacion y agenda una cita con nostros</p>
                                <a href="#" className="btn btn-lg btn-round btn-theme">Buscar</a>
                            </div>
                        </div>
                        <div className="carousel-item banner-max-height item-bg">
                        <img className="d-block w-100 h-100" src="https://firebasestorage.googleapis.com/v0/b/wti-services-jrz.appspot.com/o/banner-03.png?alt=media&token=55ec5d82-8d42-48ff-a829-3eb286172353" alt="banner"/>
                            <div className="carousel-content container banner-info-2 bi-2 text-r">
                                <h2>No busques mas</h2>
                                <p>En WTI Services estamos para ayudarte en todo tu tramite de importacion</p>
                                <a  className="btn btn-lg btn-round btn-theme">Mas info</a>
                            </div>
                        </div>                            
                        
                    </div>
                    <a className="carousel-control-prev none-580" role="button" data-slide="prev">
                        <span className="slider-mover-left" aria-hidden="true">
                            <i className="fa fa-angle-left"></i>
                        </span>
                    </a>
                    <a className="carousel-control-next none-580" role="button" data-slide="next">
                        <span className="slider-mover-right" aria-hidden="true">
                            <i className="fa fa-angle-right"></i>
                        </span>
                    </a>
                </div>
            </div>
            {/* <!-- Banner end --> */}            
        </div>
    )
}

export default Banner



// WEBPACK FOOTER //
// ./src/components/Banner.jsx